import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const TrophyIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 14 16"
  >
    <path
      fillRule="evenodd"
      d="M.25.25h13.5v3.932a2.72 2.72 0 0 1-.732 1.864c-.453.481-1.07.769-1.727.793a4.65 4.65 0 0 1-1.2 2.466 4.3 4.3 0 0 1-2.341 1.286v1.114h.45c.85 0 1.656.358 2.243.98.585.621.907 1.455.907 2.315v.75h-8.7V15c0-.86.322-1.694.907-2.314a3.08 3.08 0 0 1 2.243-.982h.45v-1.113a4.3 4.3 0 0 1-2.341-1.286 4.65 4.65 0 0 1-1.2-2.466 2.5 2.5 0 0 1-1.727-.793A2.72 2.72 0 0 1 .25 4.182zm2.4 5.079V1.75h-.9v2.432c0 .321.12.62.323.835.162.173.366.278.577.312m1.5-3.579v4.34c0 .828.31 1.614.85 2.186a2.75 2.75 0 0 0 2 .883c.741 0 1.462-.312 2-.883.54-.572.85-1.358.85-2.185V1.75zm7.2 0v3.579c.211-.034.415-.14.577-.312a1.22 1.22 0 0 0 .323-.835V1.75zM5.8 13.205c-.423 0-.838.177-1.151.51a1.8 1.8 0 0 0-.348.535H9.7a1.8 1.8 0 0 0-.348-.535 1.58 1.58 0 0 0-1.151-.51z"
      clipRule="evenodd"
    />
  </svg>
);
TrophyIcon.id = 'TrophyIcon';
TrophyIcon.displayName = 'TrophyIcon';
export default TrophyIcon;
